var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vessel-trial-test-details',{attrs:{"vessel-trial-test":_vm.vesselTrialTest}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }